module.exports = __webpack_public_path__ + "img/horizontal_3_4_r_pp2_7005.9169a7b5.png";